module.exports = __webpack_public_path__ + "static/img/Three of Swords.d601e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Three of Swords.jpg
// module id = 1327
// module chunks = 0